// extracted by mini-css-extract-plugin
export default {"container":"TasksContainer_container__Vz0XQ","heading":"TasksContainer_heading__d9GG1"};